import { atom, selector, useRecoilState } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import { savedDisplayOperationState, useDisplayOperationRecoilState } from "../hooks/useDisplayOperation";
import { getProperty } from "../utils/FPEUtils";

const mapColorState = atom({
  key: 'mapColorState',
  default: selector({
    key: 'mapColorStateSelector',
    get: ({get}) => {
      return getProperty(get(savedDisplayOperationState), 'SCREEN_SETTING.MAP_COLOR') || getCustomerSettings('mapConfig.MAP_COLOR');
    }
  })
});

const mapTypeState = atom({
  key: 'mapTypeState',
  default: selector({
    key: 'mapTypeStateSelector',
    get: ({get}) => {
      const color = get(mapColorState);
      return color === 'google' ? 'googleMap' : 'tileMap';
    }
  })
})

const mapTmpColorState = atom({
  key: 'mapTmpColorState',
  default: null
});

export const useMapColorState = () => {
  const [mapType, setMapType] = useRecoilState(mapTypeState);
  const [mapColor, setMapColor] = useDisplayOperationRecoilState("SCREEN_SETTING.MAP_COLOR", mapColorState);
  const [tmpMapColor, setTmpMapColor] = useRecoilState(mapTmpColorState);

  const isLightMap = mapColor === 'white';
  const isDarkMap = mapColor === 'black';
  const isGsiMap = mapColor === 'gsi';
  const isGoogleMap = mapType === 'googleMap';

  const changeMapColorDark = ()=>{
    if (mapType === 'googleMap') {
      setMapType('tileMap');
      setTmpMapColor('black');
    } else {
      setMapColor('black');
    }
  }
  const changeMapColorLight = () => {
    if (mapType === 'googleMap') {
      setMapType('tileMap');
      setTmpMapColor('white');
    } else {
      setMapColor('white');
    }
  };
  const changeMapColorGSI = ()=>{
    if (mapType === 'googleMap') {
      setMapType('tileMap');
      setTmpMapColor('gsi');
    } else {
      setMapColor('gsi');
    }
  }
  const changeMapColorGoogle = () => {
    if (mapType === 'tileMap') {
      setTmpMapColor('google');
      setMapType('googleMap');
    } else {
      setMapColor('google');
    }
  };

  const applyMapColor = () => {
    setMapColor(tmpMapColor);
  };

  return {
    mapColor,
    isLightMap,
    isDarkMap,
    isGsiMap,
    isGoogleMap,
    changeMapColorDark,
    changeMapColorLight,
    changeMapColorGSI,
    changeMapColorGoogle,
    applyMapColor
  }
}